module.exports = __webpack_public_path__ + "01_medium_beige.9b620522.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_medium_beige.png
// module id = Y89H
// module chunks = 0